import { defineEvent } from '../types/event';
export var QUICKVIEW_COLOR_SWATCH_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_QuickView_Colors_Swatches'
        }
    ]
});
